import React, { useState, useEffect } from "react";
import { fetchKPIs } from "../lib/auctions";

export const PlacingBid = ({
  now,
  auction,
  bidAmount,
  confirmingBid,
  onBack,
  onBuyWithCard,
  statefulCurrentPrice,
  setStatefulCurrentPrice,
}) => {
  const [timeLeft, setTimeLeft] = useState(now);
  // const [statefulCurrentPrice, setStatefulCurrentPrice] = useState(currentBid);

  useEffect(() => {
    async function executor() {
      switch (auction.kind) {
        case "GDAContinuous": {
          break;
        }
        case "GDADiscrete": {
          break;
        }
      }
    }

    executor();
  }, []);
  return (
    <div>
      {auction.kind === "Ascending" && (
        <>
          <p className="text-base opacity-50">Current bid:</p>
          <h1 className="text-4xl 5xl:text-5xl font-medium opacity-50">
            {statefulCurrentPrice.toFixed(2)} USD
          </h1>
          <p className="text-base opacity-100">Your bid:</p>
          <h1 className="text-4xl 5xl:text-5xl font-medium">
            {bidAmount.toFixed(2)} USD
          </h1>
        </>
      )}
      {auction.kind === "GDAContinuous" && (
        <>
          <p className="text-base opacity-50">Current Price:</p>
          <h1 className="text-4xl 5xl:text-5xl font-medium opacity-50">
            {statefulCurrentPrice.toFixed(2)} USD
          </h1>
          <p className="text-base opacity-100">Buying:</p>
          <h1 className="text-4xl 5xl:text-5xl font-medium">
            {bidAmount} Items
          </h1>
        </>
      )}
      {auction.kind === "GDADiscrete" && (
        <>
          <p className="text-base opacity-50">Current Price:</p>
          <h1 className="text-4xl 5xl:text-5xl font-medium opacity-50">
            {statefulCurrentPrice.toFixed(2)} USD
          </h1>
          <p className="text-base opacity-100">Buying:</p>
          <h1 className="text-4xl 5xl:text-5xl font-medium">
            {bidAmount} Items
          </h1>
        </>
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            padding: "1.5rem",
          }}
        >
          {confirmingBid && (
            <span className="text-base opacity-50">Please Wait...</span>
          )}
          {!confirmingBid && (
            <span className="text-base opacity-50">
              By placing your bid, you’re committing to buy this item if you win
              the auction. You will be charged 3% of the total auction cost to
              place your bid. If you do not win, this cost will be refunded to
              you.
            </span>
          )}
        </div>
        {!confirmingBid && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <button onClick={onBuyWithCard} theme={"solid-dark"} type="submit">
              Confirm
            </button>
            <button onClick={onBack} theme={"solid-light"} type="submit">
              Back
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
